import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";
import { createRouteError } from "../../../components/RouteErrorBoundary";
import { PageSkeleton } from "../../../components/RouteSkeleton";
import { ProfileLayout } from "../../../components/profile/ProfileLayout";
import { PERSONAL_PROFILE_SECTIONS } from "../../../config/personal-navigation.config";

const profileSearchSchema = z.object({
  section: z.enum(PERSONAL_PROFILE_SECTIONS).optional().default("overview"),
});

export const Route = createFileRoute("/_admin/profile/")({
  validateSearch: profileSearchSchema,
  beforeLoad: async ({ context }) => {
    if (typeof window === "undefined") return {};
    const sb = context.supabase;
    if (!sb) return {};
    const {
      data: { session },
    } = await sb.auth.getSession();
    if (!session) {
      throw redirect({ to: "/auth" });
    }
    return { session };
  },
  pendingComponent: () => <PageSkeleton rows={4} variant="cards" />,
  errorComponent: createRouteError("Profile"),
  component: ProfileLayout,
});
